import { ZgAuthZone } from '@zg-rentals/ts-id-verification-client';
import { TermSet } from '../../../models';

export function getZgAuthZoneFromTermSet(termSet: TermSet): ZgAuthZone {
  switch (termSet) {
    case TermSet.RenterScreening:
      return ZgAuthZone.ZILLOW;
    case TermSet.LandlordScreening:
      return ZgAuthZone.ZRM;
    default:
      return ZgAuthZone.ZILLOW;
  }
}
